<template>
    <div class="page_content online-defense-list" v-loading="loading">
        <h1 class="head_title">在线答辩</h1>
        <el-alert
            v-if="!capabilities.enabled && loaded"
            title="在线答辩功能暂未开启"
            type="info"
            :closable="false"
            show-icon>
        </el-alert>
        <el-alert
            v-if="loadError"
            title="在线答辩信息加载失败，请重试"
            type="error"
            show-icon
            :closable="false">
            <el-button type="text" @click="loadPage">重新加载</el-button>
        </el-alert>
        <template v-if="loaded && !loadError && capabilities.enabled">
            <el-table v-if="groupList.length > 0" :data="groupList" border style="width: 100%">
                <el-table-column prop="onlineDefenseSessionTitle" label="活动名称" min-width="180"></el-table-column>
                <el-table-column prop="onlineDefenseGroupName" label="答辩分组" width="140"></el-table-column>
                <el-table-column prop="groupStartTime" label="开始时间" width="170"></el-table-column>
                <el-table-column prop="groupEndTime" label="结束时间" width="170"></el-table-column>
                <el-table-column prop="materialDeadline" label="资料截止时间" width="170"></el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="groupStatusType(scope.row.onlineDefenseGroupStatus)" size="small">
                            {{ groupStatusText(scope.row.onlineDefenseGroupStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-empty v-else description="暂无在线答辩安排"></el-empty>
        </template>
    </div>
</template>

<script>
export default {
    name: 'OnlineDefenseList',
    data() {
        return {
            loading: false,
            loaded: false,
            capabilities: {},
            groupList: [],
            loadError: false
        };
    },
    created() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.loading = true;
            this.loadError = false;
            this.$store.dispatch('onlineDefense/getCapabilities').then((ret) => {
                if (ret.code != 0 && ret.code != '0') {
                    this.loadError = true;
                    this.$message.error(ret.msg || '获取在线答辩能力失败');
                    return;
                }
                this.capabilities = ret.data || {};
                if (!this.capabilities.enabled) {
                    return;
                }
                return this.$store.dispatch('onlineDefense/getList').then((listRet) => {
                    if (listRet.code == 0 || listRet.code == '0') {
                        this.groupList = listRet.data || [];
                    } else {
                        this.loadError = true;
                        this.$message.error(listRet.msg || '获取在线答辩列表失败');
                    }
                });
            }).catch(() => {
                this.loadError = true;
                this.$message.error('获取在线答辩信息失败，请稍后重试');
            }).finally(() => {
                this.loading = false;
                this.loaded = true;
            });
        },
        openDetail(group) {
            this.$router.push({
                name: 'OnlineDefenseDetail',
                query: { onlineDefenseGroupId: group.onlineDefenseGroupId }
            });
        },
        groupStatusText(status) {
            return {
                1: '待创建',
                2: '创建中',
                3: '已就绪',
                4: '进行中',
                5: '归档中',
                6: '已归档',
                7: '失败',
                8: '已取消'
            }[status] || '未知';
        },
        groupStatusType(status) {
            if (status == 3 || status == 4) return 'success';
            if (status == 7 || status == 8) return 'danger';
            return 'info';
        }
    }
};
</script>

<style scoped lang="less">
.online-defense-list {
    min-height: calc(100vh - 100px);
}
</style>



// WEBPACK FOOTER //
// src/pages/onlineDefense/OnlineDefenseList.vue